import React from 'react'
import { useIntl } from 'react-intl'

import { useAppDispatch } from 'hooks/reduxHooks'
import { initialiseBnblOfferModal } from 'actions/BnblModalActions'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import { BnblSteps, getBnblPackageViewByNumberOfRooms } from 'components/OfferPage/BnblModal/utils'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { getBnblPackageViews } from 'selectors/offerPage/offerPageSelectors'

interface MappedProps {
  numberOfRooms: number
  baseBnblPackageViews: Array<App.OfferPackageOptionView>
}

interface Props {
  offerId: string
  selectedPackageUniqueKey: string
  setStep: (step: BnblSteps) => void
  isGift?: boolean
}

function BnblSwitchPackageDurationStepFooter({
  baseBnblPackageViews,
  numberOfRooms,
  offerId,
  selectedPackageUniqueKey,
  setStep,
  isGift,
}: Props & MappedProps) {
  const intl = useIntl()
  const dispatch = useAppDispatch()

  const onSaveSwitchPackageDuration = () => {
    // update the package view so that the modal reflects the selected duration
    const newSelectedPackageView = baseBnblPackageViews.find(baseBnblPackageView => baseBnblPackageView.package.uniqueKey === selectedPackageUniqueKey)
    if (newSelectedPackageView) {
      const newPackages = [{
        packageView: getBnblPackageViewByNumberOfRooms(newSelectedPackageView, numberOfRooms),
        numberOfRooms,
      }]
      // Resets modal packages with the new duration
      dispatch(initialiseBnblOfferModal(newPackages, offerId, !!isGift))
      setStep(isGift ? BnblSteps.GIFT : BnblSteps.HOME)
    }
  }

  return (
    <ModalFooter
      primaryActionProps={{
        children: intl.formatMessage({
          id: 'iYDPDZG6Kg',
          defaultMessage: 'Apply',
          description: 'Button to apply the selected package duration in BNBL switch duration step',
        }),
        onClick: onSaveSwitchPackageDuration,
        disabled: false,
      }}
    />
  )
}

export default withOfferPageAndReduxState((offerPageState, appState: App.State, ownProps: Props): MappedProps => {
  const bnblModalPackages = appState.offer.bnblModal[ownProps.offerId]
  const { numberOfRooms } = bnblModalPackages[0]

  return {
    numberOfRooms,
    baseBnblPackageViews: getBnblPackageViews(offerPageState),
  }
}, BnblSwitchPackageDurationStepFooter)
